/**
 *
 * AudiencesAddNew
 *
 */

import React, { useState, useEffect, useCallback } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { Button, Form } from "antd";

// components
import TCFModal from "components/TCFModal";
import DynamicMultipleSelect from "components/Forms/Fields/DynamicMultipleSelect";
import { NotificationSimple } from "components/Notifications";

function AudiencesAddNew({
  open,
  editable,
  isEditEnabeled,
  isLoading,
  isSuccess,
  showNotification,
  // actions
  setOpen,
  onAdd,
  // default props
  className,
}) {
  const childClassNames = classNames("audiences-add-new-modal", className);
  const { t } = useTranslation();

  const [audiencesAddNewForm] = Form.useForm();

  const [showSuccess, setShowSuccess] = useState(false);

  const [newAudiences, setNewAudiences] = useState({
    students: [],
    users: [],
    studentsID: [],
    usersID: [],
  });

  useEffect(() => {
    audiencesAddNewForm.resetFields();
    return () => {
      setNewAudiences({
        students: [],
        users: [],
        studentsID: [],
        usersID: [],
      });
      !showNotification && setShowSuccess(false);
      audiencesAddNewForm.resetFields();
    };
  }, []);

  const onCancelModalHandler = useCallback(() => {
    !!setOpen && setOpen(false);
    !showNotification && setShowSuccess(false);
    audiencesAddNewForm.resetFields();
  }, [setOpen]);

  const onAddElementHandler = useCallback(() => {
    if (!isLoading) {
      !!onAdd && onAdd(newAudiences);
      !!setOpen && setOpen(false);
      !showNotification && setShowSuccess(true);
      audiencesAddNewForm.resetFields();
    }
  }, [onAdd, setOpen, isLoading, newAudiences]);

  // return: { students: [object], users: [object], studentsID: ['_id'], usersID: ['_id'] }
  const onChangeAudienceSelect = useCallback(
    (values, options) => {
      let result = {
        students: [],
        users: [],
        studentsID: [],
        usersID: [],
      };
      if (Array.isArray(options) && options.length > 0) {
        options?.map(option => {
          if (option?.group) {
            let arr = result[(option?.group)] || [];
            let newArr = arr.concat([option.item]);
            let arrIDs = result[`${option?.group}ID`] || [];
            let newArrIDs = arrIDs.concat([option.value]);
            result = {
              ...result,
              [option?.group]: newArr,
              [`${option?.group}ID`]: newArrIDs,
            };
          }
        });
      }
      setNewAudiences(result);
    },
    [newAudiences],
  );

  return (
    !!editable &&
    !!isEditEnabeled && (
      <>
        <NotificationSimple
          Loading={!!showNotification && isLoading}
          Successful={(!showNotification && showSuccess) || isSuccess}
          message={t("notifications.during")}
          messageSuccess={t("notifications.memberAdded")}
          description=""
          type="update"
        />
        <Button
          type="default"
          className="ant-btn-add-audience"
          onClick={() => setOpen(true)}
        >
          {t("audiences.addNewMember")}
        </Button>
        <TCFModal
          className={childClassNames}
          open={open}
          setOpen={setOpen}
          title={t("audiences.addNewMember")}
          loading={isLoading}
          confirmLoading={isSuccess}
          onCancel={onCancelModalHandler}
          onOk={onAddElementHandler}
        >
          <Form
            key="audiences-add-new-modal-form"
            form={audiencesAddNewForm}
            name="audiences-add-new-modal-form"
            autoComplete="off"
          >
            <DynamicMultipleSelect
              key="axios-select-multiple-modal"
              index="axios-select-multiple-modal"
              mode="new"
              method="new"
              onChange={onChangeAudienceSelect}
              className={classNames(
                "custom-form-column",
                "dynamic-multiple-select-column",
              )}
              data={{
                label: t("labels.audience"),
                name: "audience-modal-select",
                endponit: `communications/audience/by/students,users`,
                endponitSend: null,
                displayLabel: false,
                required: true,
                type: "axios-select-multiple",
                hasModeView: true,
                col: 24,
                method: "POST",
                groupped: true,
                optionLabelProp: "title", // 'label
                value: [],
                className: "axios-select",
                mode: "multiple",
                isSearch: true,
                placeholder: t("audiences.selectAudience"),
                showAsTag: true,
              }}
            />
          </Form>
        </TCFModal>
      </>
    )
  );
}

AudiencesAddNew.defaultProps = {
  open: false,
  isLoading: false,
  isSuccess: false,
  showNotification: false,
};

export default AudiencesAddNew;
